<template>
  <div class="lmnr1 container">
    <NavList :init-nav-id="nid" @articleNav="getData($event)"/>

    <div class="fr lmnr2 col-md-9" style="padding: 0 2rem;">
      <h1>{{ navTitle }}</h1>
      <div v-if="article" v-html='article.content' class="lmnr3"></div>
      <div v-if="articles" class="xwlb3 bdn">
        <ul class="xwlb">
          <li v-for="item in articles" :key="item.id">
            <div class="rq13">
              <span>{{handleDate('singleDay',item.published_at)}}</span>
              <p>{{handleDate('month',item.published_at)}}</p>
            </div>
            <div class="bt111"><a href="javascrip:;">{{item.title}}</a></div>
            <div class="wzms1"><p>{{ item.desc }}</p><a :href="'/article/detail/'+item.id">查看详细 →</a></div>
          </li>
          <div class="clear"></div>
        </ul>
<!--        <div class="meneame">
          <a class="thisclass">首页</a>
          <a class="thisclass">1</a>
          <a href="list_38_2.html">2</a>
          <a href="list_38_3.html">3</a>
          <a class="bd0" href="list_38_2.html">&gt;</a>
          <a class="bd0" href="list_38_3.html">末页</a>
        </div>-->
      </div>
    </div>

    <div class="clear"></div>
  </div>
</template>
<script>
import NavList from "@/components/NavList"
import {getArticles} from "@/api/home"
import {getFormatDate,imgSrc} from "@/utils"
export default {
  components: {NavList},
  data() {
    return {
      nid: parseInt(this.$route.params.nid),
      navTitle: '',
      article: null,
      articles: []
    }
  },
  methods: {
    getData(articleNav) {
      this.navTitle = articleNav.name
      const temp4 = {nav: articleNav.id}
      getArticles(temp4).then((response) => {
        console.log('res nav/list',response)
        const temp = response
        if (temp.length > 1) {
          this.articles = response
        } else {
          this.article = response[0]
          this.article.content = imgSrc(this.article.content)
        }
      })
    },
    handleDate(n){
      return getFormatDate(n)
    }
  }
}
</script>